import { apiRequest } from "../util/apiUtils";

export const paymentGetwayList = async (params) => {
  try {
    const res = await apiRequest("get", `payment/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const paymentGetwayAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `payment/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const paymentGetwayDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `payment/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const paymentGetwayStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `payment/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
